import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import './config/axios'
import './config/moeda'
import './config/icons'
import './config/msg'

import logger from './utils/logger'

Vue.config.productionTip = false

Vue.config.errorHandler = (err, vm, info) => {
  logger.error(`[Global Vue Error] ${err.toString()}\nInfo: ${info}\nStack: ${err.stack}`);
};

Vue.filter('dinheiro', valor => {
  return valor == null || isNaN(valor) ? 'R$ 0,00' : valor.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
})

Vue.filter('dinheiroDecimal', valor => {
  return valor == null || isNaN(valor) ? 'R$ 0,00' : valor.toLocaleString('pt-br', { style: 'currency', currency: 'BRL', minimumFractionDigits: 4 });
})

new Vue({
  vuetify,
  render: h => h(App)
}).$mount('#app')
